import { RouteConfig } from 'vue-router'

const IndexSF = () => import('../activity/splus/sf-2026/Index.vue')
const IndexSV = () => import('../activity/splus/sv-2025/Index.vue')
const IndexCC = () => import('../activity/splus/cc-2026/Index.vue')
const IndexTB = () => import('../activity/splus/tb-2025/Index.vue')
const IndexSFNew = () => import('../activity/splus/sf-2026-new/Index.vue')
const WinnersSFNew = () => import('../activity/splus/sf-2026-new/Winners.vue')
const SplusRewardsSF = () => import('../activity/splus/sf-2026/SplusRewards.vue')
const SplusRewardsSFNew = () => import('../activity/splus/sf-2026-new/SplusRewards.vue')
const LotteryRewardsSFNew = () => import('../activity/splus/sf-2026-new/LotteryRewards.vue')

const IndexCaa = () => import('../activity/splus/caa-2026/Index.vue')
const WinnersCaa = () => import('../activity/splus/caa-2026/Winners.vue')
const SplusRewardsCaa = () => import('../activity/splus/caa-2026/SplusRewards.vue')
const LotteryRewardsCaa = () => import('../activity/splus/caa-2026/LotteryRewards.vue')

const IndexLD = () => import('../activity/splus/ld-2026/Index.vue')
const WinnersLD = () => import('../activity/splus/ld-2026/Winners.vue')
const SplusRewardsLD = () => import('../activity/splus/ld-2026/SplusRewards.vue')
const LotteryRewardsLD = () => import('../activity/splus/ld-2026/LotteryRewards.vue')

export const indexSFRoute: RouteConfig = {
  path: '/activity/splus/sf-2026',
  name: 'activity_splus_sf_2026',
  component: IndexSF,
  meta: {
    title: '神马卡预售来袭',
  },
}

export const indexSVRoute: RouteConfig = {
  path: '/activity/splus/sv-2025',
  name: 'activity_splus_sv_2025',
  component: IndexSV,
  meta: {
    title: '运动一夏 挑战赛',
  },
}

export const indexCCRoute: RouteConfig = {
  path: '/activity/splus/cc-2026',
  name: 'activity_splus_cc_2026',
  component: IndexCC,
  meta: {
    title: '天天运动 赢返现',
  },
}

export const indexTBRoute: RouteConfig = {
  path: '/activity/splus/tb-2025',
  name: 'activity_splus_tb_2025',
  component: IndexTB,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '7天S+会员免费体验',
  },
}

export const indexSFNewRoute: RouteConfig = {
  path: '/activity/splus/sf-2026-new',
  name: 'activity_splus_sf_2026_new',
  component: IndexSFNew,
  redirect: '/activity/splus/sf-2026-new/winners',
  meta: {
    title: '舞狮纳福贺新岁',
  },
}

export const winnersSFNewRoute: RouteConfig = {
  path: '/activity/splus/sf-2026-new/winners',
  name: 'activity_splus_sf_2026_new_winners',
  component: WinnersSFNew,
  meta: {
    title: '舞狮纳福贺新岁',
  },
}

export const splusRewardsSFRoute: RouteConfig = {
  path: '/activity/splus/sf-2026/splus-rewards',
  name: 'activity_splus_sf_2026_splus_rewards',
  component: SplusRewardsSF,
  meta: {
    title: '已选奖品记录',
  },
}

export const splusRewardsSFNewRoute: RouteConfig = {
  path: '/activity/splus/sf-2026-new/splus-rewards',
  name: 'activity_splus_sf_2026_new_splus_rewards',
  component: SplusRewardsSFNew,
  meta: {
    title: '已选奖品记录',
  },
}

export const lotteryRewardsSFNewRoute: RouteConfig = {
  path: '/activity/splus/sf-2026-new/lottery-rewards',
  name: 'activity_splus_sf_2026_new_lottery_rewards',
  component: LotteryRewardsSFNew,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export const indexCaaRoute: RouteConfig = {
  path: '/activity/splus/caa-2026',
  name: 'activity_splus_caa_2026',
  component: IndexCaa,
  redirect: '/activity/splus/caa-2026/winners',
  meta: {
    title: '沧海学院封神会',
  },
}

export const winnersCaaRoute: RouteConfig = {
  path: '/activity/splus/caa-2026/winners',
  name: 'activity_splus_caa_2026_winners',
  component: WinnersCaa,
  meta: {
    title: '沧海学院封神会',
  },
}

export const splusRewardsCaaRoute: RouteConfig = {
  path: '/activity/splus/caa-2026/splus-rewards',
  name: 'activity_splus_caa_2026_splus_rewards',
  component: SplusRewardsCaa,
  meta: {
    title: '已选奖品记录',
  },
}

export const lotteryRewardsCaaRoute: RouteConfig = {
  path: '/activity/splus/caa-2026/lottery-rewards',
  name: 'activity_splus_caa_2026_lottery_rewards',
  component: LotteryRewardsCaa,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export const indexLDRoute: RouteConfig = {
  path: '/activity/splus/ld-2026',
  name: 'activity_splus_ld_2026',
  component: IndexLD,
  redirect: '/activity/splus/ld-2026/winners',
  meta: {
    title: '探索古埃及文化',
  },
}

export const winnersLDRoute: RouteConfig = {
  path: '/activity/splus/ld-2026/winners',
  name: 'activity_splus_ld_2026_winners',
  component: WinnersLD,
  meta: {
    title: '探索古埃及文化',
  },
}

export const splusRewardsLDRoute: RouteConfig = {
  path: '/activity/splus/ld-2026/splus-rewards',
  name: 'activity_splus_ld_2026_splus_rewards',
  component: SplusRewardsLD,
  meta: {
    title: '已选奖品记录',
  },
}

export const lotteryRewardsLDRoute: RouteConfig = {
  path: '/activity/splus/ld-2026/lottery-rewards',
  name: 'activity_splus_ld_2026_lottery_rewards',
  component: LotteryRewardsLD,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export default [
  // format
  indexSFRoute,
  indexSVRoute,
  indexCCRoute,
  indexTBRoute,
  indexSFNewRoute,
  winnersSFNewRoute,
  splusRewardsSFRoute,
  splusRewardsSFNewRoute,
  lotteryRewardsSFNewRoute,
  indexCaaRoute,
  winnersCaaRoute,
  splusRewardsCaaRoute,
  lotteryRewardsCaaRoute,
  indexLDRoute,
  winnersLDRoute,
  splusRewardsLDRoute,
  lotteryRewardsLDRoute,
]
